import fetchGql, { gql } from '../../util/fetchGql';
import Seo, { SEO_FRAGMENT } from '../../components/Seo';
import Hero from '../../components/Hero';
import FaqsContent, {
	FAQS_CATEGORY_FRAGMENT,
	FAQS_ENTRY_FRAGMENT
} from '../../components/FaqsContent';

export default function Faqs ({ seo, categories, entries, entry }) {
	return (
		<>
			<Seo seo={seo} />
			<Hero
				heading="FAQs"
				text={entry?.excerpt}
			/>
			<FaqsContent
				categories={categories}
				entries={entries}
			/>
		</>
	);
}

export async function getStaticProps ({ params, ...ctx }) {
	const slug = params?.slug;

	const data = await fetchGql(gql`
        query GetFaqs ($slug: String) {
            categories (group: "faqCategory") {
                ... FaqsCategory
            }

            category (
                group: "faqCategory"
                slug: [$slug]
            ) {
                ... on faqCategory_Category {
                    seo { ...Seo }
                }
            }

            entries (
                section: "faq"
                relatedToCategories: [{ slug: [$slug] }]
            ) {
                ...FaqsEntry
            }

            entry (
                section: "faqs"
            ) {
                ... on faqs_faqs_Entry {
                    excerpt
                }
            }
        }
        ${SEO_FRAGMENT}
        ${FAQS_CATEGORY_FRAGMENT}
        ${FAQS_ENTRY_FRAGMENT}
	`, {
		slug,
	}, ctx);

	return {
		props: {
			...data.category,
			entries: data.entries,
			entry: data.entry,
			categories: data.categories,
		},
		
	};
}

export async function getStaticPaths () {
	const data = await fetchGql(gql`{
        categories (group: "faqCategory") {
            typeHandle: groupHandle
            slug
        }
	}`);

	return {
		paths: data.categories.map(e => ({ params: { ...e, slug: e.slug } })),
		fallback: 'blocking',
	};
}
